module.exports = __webpack_public_path__ + "ptc_momoro_G2_2.cdecc3da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_G2_2.jpg
// module id = jnUY
// module chunks = 0